<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="this.option"
      @vdropzone-error-multiple="processError"
      @vdropzone-success-multiple="processSuccess"
      @vdropzone-sending="sending"
      @vdropzone-error="handleError"
    >
    </vue-dropzone>
    <div class="info">
      <b class="text-red">※ファイルのアップロードは「アップロード」ボタンを押すことで完了となります。</b>
      <br>
      <span>※アップロードボタンを押した後、アップロード完了するまでしばらくお待ちください</span>
    </div>
    <div v-if="shareLink">
      <div class="text-left m-t">
        <span class="fa fa-check-circle-o" aria-hidden="true" style="color: #5cb85c">
          <a :href="shareLink" target="_blank" class="share-link">アップロード済みファイル確認</a>
        </span>
      </div>
    </div>
    <div class="text-right m-t">
      <button
        class="btn btn-warning m-w-120"
        @click="updateFiles"
      >
        アップロード
      </button>
      <button type="button" class="btn m-w-120" data-dismiss="modal" @click="$emit('close')">閉じる</button>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import store from '@/store'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  props: {
    uploadUrl: {
      type: String
    },
    asin: {
      type: String
    },
    shareLink: {
      type: String
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      loader: null,
      uploadErrorMessage: `
        <span class="text-red font-bold"><i class="fa fa-exclamation-triangle text-size-20 mr-r-5" aria-hidden="true"></i>審査用データのアップロードに失敗しました</span><br><br>
        ・ しばらく時間をおいて再度お試しください。<br>
        ・ 繰り返しエラーとなる場合は、Chatworkにてデータをご送付ください。
      `
    }
  },
  computed: {
    option () {
      return {
        url: `${process.env.NODE_SERVER_API + this.uploadUrl}`,
        headers: { 'Authorization': `Bearer ${localStorage.getItem('tokenSalmon')}` },
        thumbnailWidth: 150,
        maxFilesize: 150,
        addRemoveLinks: false,
        autoProcessQueue: false,
        uploadMultiple: true,
        dictDefaultMessage: '審査に必要なファイルを、ここにドラッグ＆ドロップ<br><br><button class="btn btn-info w-200">またはファイルを選択</button>',
        dictInvalidFileType: 'この形式のファイルはアップロードできません。',
        dictMaxFilesExceeded: '複数のファイルをアップロードすることはできません。',
        dictFileTooBig: 'ファイルサイズが大きすぎます（最大: {{maxFilesize}}MB）',
        previewTemplate: `
          <div class="dz-preview custom-dz">
            <div class="file-icon">
              <i class="fa fa-file-text-o text-size-35" aria-hidden="true"></i>
            </div>
            <div class="file-info">
              <div class="file-name" data-dz-name></div>
              <div class="file-size" data-dz-size></div>
              <div class="file-error" data-dz-errormessage></div>
            </div>
            <div class="file-status">
              <i class="fa fa-check-circle text-success text-size-20" aria-hidden="true"></i>
              <button class="btn" data-dz-remove>
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        `
      }
    }
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  },
  methods: {
    sending (file, xhr, formData) {
      formData.append('asin', this.asin)
    },
    handleError (file) {
      const icon = file.previewElement.querySelector('.file-icon i')

      if (icon) {
        icon.classList.remove('fa-file-text-o')
        icon.classList.add('fa-exclamation-triangle')
        icon.classList.add('text-danger')
      }

      const statusIcon = file.previewElement.querySelector('.file-status i')
      if (statusIcon) {
        statusIcon.classList.remove('fa-check-circle')
        statusIcon.classList.remove('text-success')
        statusIcon.classList.add('fa-exclamation-triangle')
        statusIcon.classList.add('text-danger')
      }
    },
    processError (file, response, xhr) {
      if (xhr) {
        store.commit('toggleModal', {
          show: true,
          message: this.uploadErrorMessage,
          modalWidth: 600
        })
        self.loader && self.loader.hide()
      }
    },
    processSuccess (file, response) {
      store.commit('toggleModal', {
        show: true,
        message: '審査用画像のアップロードに成功しました'
      })
      this.$emit('refresh')
      self.loader && self.loader.hide()
    },
    updateFiles () {
      const dz = this.$refs.myVueDropzone
      const rejectedFiles = dz.getRejectedFiles()
      if (rejectedFiles.length > 0) {
        return
      }

      const queuedFiles = dz.getQueuedFiles()
      if (queuedFiles.length) {
        self.loader = this.$loading.show()
        this.$refs.myVueDropzone.processQueue()
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    }
  },
  watch: {
    asin (newVal, oldVal) {
      this.$refs.myVueDropzone.removeAllFiles()
    }
  }
}
</script>

<style scoped>
.info {
  margin-top: 8px;
}

.share-link {
  margin-right: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageInput.vue